import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "toolbar",
  id: "kt_toolbar",
  style: {"display":"none"}
}
const _hoisted_2 = {
  id: "kt_toolbar_container",
  class: "container-fluid d-flex flex-stack"
}
const _hoisted_3 = { class: "page-title d-flex align-items-center me-3 flex-wrap mb-5 mb-lg-0 lh-1" }
const _hoisted_4 = { class: "d-flex align-items-center text-dark fw-bolder my-1 fs-3" }
const _hoisted_5 = {
  key: 0,
  class: "h-20px border-gray-200 border-start mx-4"
}
const _hoisted_6 = {
  key: 1,
  class: "breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1"
}
const _hoisted_7 = { class: "breadcrumb-item pe-3" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Home ")
const _hoisted_9 = /*#__PURE__*/_createVNode("li", { class: "breadcrumb-item" }, [
  /*#__PURE__*/_createVNode("span", { class: "bullet bg-gray-200 w-5px h-2px" })
], -1)
const _hoisted_10 = { class: "breadcrumb-item text-muted" }
const _hoisted_11 = /*#__PURE__*/_createVNode("li", { class: "breadcrumb-item" }, [
  /*#__PURE__*/_createVNode("span", { class: "bullet bg-gray-200 w-5px h-2px" })
], -1)
const _hoisted_12 = { class: "breadcrumb-item pe-3 text-dark" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "d-flex align-items-center gap-2 flex-wrap" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("h1", _hoisted_4, _toDisplayString(_ctx.title), 1),
        (_ctx.breadcrumbs)
          ? (_openBlock(), _createBlock("span", _hoisted_5))
          : _createCommentVNode("", true),
        (_ctx.breadcrumbs)
          ? (_openBlock(), _createBlock("ul", _hoisted_6, [
              _createVNode("li", _hoisted_7, [
                _createVNode(_component_router_link, {
                  to: "/dashboard",
                  class: "text-muted text-hover-primary"
                }, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 1
                })
              ]),
              _hoisted_9,
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.breadcrumbs, (item, index) => {
                return (_openBlock(), _createBlock(_Fragment, { key: index }, [
                  _createVNode("li", _hoisted_10, _toDisplayString(item), 1),
                  _hoisted_11
                ], 64))
              }), 128)),
              _createVNode("li", _hoisted_12, _toDisplayString(_ctx.title), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _hoisted_13
    ])
  ]))
}